export const DEFAULT_SENDER = 'Barta <hello@barta.shop>'

export function senderName(fromEmail: string) {
  const from = fromEmail.trim() || DEFAULT_SENDER
  const match = from.match(/^\s*"?([^"<]*?)"?\s*<([^>]+)>\s*$/)
  if (match && match[1]) return { name: match[1], address: match[2] }
  const address = match ? match[2] : from
  // The API names a bare address "Barta" when it saves the draft.
  return { name: 'Barta', address }
}
